<style scoped>
.txt-informasi{
    color: #2F4EA7;    
}
/* .card-welcome {
  background: #ee0979;
  background: -webkit-linear-gradient(45deg, #ee0979, #ff6a00)!important;
  background: linear-gradient(45deg, #ee0979, #ff6a00)!important;
} */
</style>
<template>
  <!-- ======== COUNTER PELATIHAN ======== -->
  <CRow>
    <div class="col-xl-6 col-sm-12 col-lg-6 col-md-6 col-12 d-flex">
      <div class="card border-0 bg-primary flex-fill">
        <div class="card-body text-white py-4 card-welcome">
          <div class="card-text py-3 px-3">
            <h3>Selamat Datang, {{ name ? name : '- - -'}}!</h3>
            <p class="py-0 mb-2 h5">Institut Akuntan Publik Indonesia</p>
            <p class="h6">Back Office System</p>
          </div>
          <div class="card-footer text-right border-0 p-0 bg-primary">
            <h6>{{ tanggal }}</h6>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-6 col-sm-12 col-lg-6 col-md-6 col-12 d-flex">
      <div class="card border-0 flex-fill">
        <div class="card-body">
          <div class="card-text text-center">
            <h4 class="text-info font-weight-bold py-1 txt-informasi">Informasi Umum</h4>
            <div
              id="carouselExampleControls"
              class="carousel slide"
              data-ride="carousel"
            >
              <div class="carousel-inner">
                <div :class=" index == 0 ? 'carousel-item active' : 'carousel-item'" v-for="(value, index) in items" v-bind:key="index">
                  <p> {{value.deskripsi.substr(0,350) + '...'}} </p>
                </div>
              </div>              
            </div>
          </div>
        </div>
      </div>
    </div>
  </CRow>
  <!-- ======== END COUNTER PELATIHAN ======== -->
</template>

<script>
import InformasiService from "../../services/datamaster/informasi-umum.service";
export default {
  name: "TopCard",
  data() {
    return {
      name : '',
      tanggal : '',
      items : [],
    };
  },
  mounted() {
    var user = JSON.parse(localStorage.getItem('user'));
    this.name = user.name;
    this.getData("0", 5, "default");
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    today = dd + '/' + mm + '/' + yyyy;
    this.tanggal = today

    
  },
  methods: {
    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      InformasiService.getInformasiUmum(currentPage, pageSize, filter)
      .then(response => {
        loader.hide();          
        this.items = response.data.data.content;          
      })
      .catch(error => {
        // comment console console.log(error);
      });
    },
  }
}

</script>
